import React, { useEffect } from "react";
import { auth } from "../firebase-config";
import Logo from '../assets/Logo.png';
import { onAuthStateChanged } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { setUid } from "../redux/userReducer";
import { useDispatch } from "react-redux";

const Header = () => {


    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/login')
            } else {
                dispatch(setUid(user.uid))
            }
        })
        return () => unsubscribe()
    }, [])

    const signOutUser = async () => {
        await auth.signOut();
    }

    return (<div style={{ borderBottom: '1px solid #d3d3d3', paddingBottom: '10px', display: 'flex', alignItems: 'center', width: 'calc(100% - 20px)', justifyContent: 'space-between', marginBottom: '20px' }}>
        <img src={Logo} style={{ width: '120px', marginLeft: '20px' }} />
        <Link className="textButton" style={{ textDecoration: 'none', color: (window.location.href.split('/')[3] === '' || window.location.href.includes('/?')) ? '#FF7100' : 'black' }} to={'/'}>Users</Link>
        <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/kpiRatings') ? '#FF7100' : 'black' }} to={'/kpiRatings'}>KPI Ratings</Link>
        <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/companies') ? '#FF7100' : 'black' }} to={'/companies'}>Companies</Link>
        <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/ratingsData') ? '#FF7100' : 'black' }} to={'/ratingsData'}>Ratings Data</Link>
        {/* <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/calendar') ? '#FF7100' : 'black' }} to={'/calendar'}>Calendar</Link> */}
        <button style={{ marginTop: 0, padding: '10px', borderRadius: '4px' }} onClick={signOutUser}> Sign out</button>
    </div>)
}

export default Header